import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Autosuggest from 'react-autosuggest';
import PropTypes from 'prop-types';

import AdminAPI from '../../../../api/AdminApi';

const LookupContainer = styled.div`
  margin-left: auto;
  margin-right: 10px;
  float: left;
  margin-top: 15px;
  height: 35px;
  line-height: 48px;
  width: 100%;
`;

const ClearFixDiv = styled.div`
  &::after {
    display: block;
    content: '';
    clear: both;
  }
`;

const AutoComplete = styled.div`
  .react-autosuggest__container {
    position: relative;
  }
  .react-autosuggest__input {
    width: 100%;
    height: 35px;
    padding: 10px 20px;
    font-family: ${props => props.theme.font.default};
    font-weight: 300;
    font-size: 14px;
    border: 1px solid ${props => props.theme.color.border};
    border-radius: 4px;
    color: ${props => props.theme.color.base2};
  }
  .react-autosuggest__input--focused {
    outline: none;
  }
  .react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .react-autosuggest__suggestions-container {
    display: none;
  }

  .react-autosuggest__suggestions-container--open {
    display: block;
    position: absolute;
    width: 100%;
    border: 1px solid ${props => props.theme.color.border};
    background-color: ${props => props.theme.color.white};
    font-family: ${props => props.theme.font.default};
    color: ${props => props.theme.color.base2};
    font-weight: 300;
    font-size: 14px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    z-index: 2;
    border-top: none;
    max-height: 180px;
    overflow-y: auto;
    box-shadow: ${props => props.theme.boxShadow['3']};
    border-radius: 2px;
  }

  .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  .react-autosuggest__suggestion {
    cursor: pointer;
    padding: 10px 20px;
  }

  .react-autosuggest__suggestion--highlighted {
    background-color: #ddd;
  }
`;

const getSuggestionValue = suggestion => suggestion.companyName;

const renderSuggestion = suggestion => (
  <div>
    {suggestion.companyName} - {suggestion.companyCode}
  </div>
);

class AddNewCompanyCode extends Component {
  static propTypes = {
    businessEntityId: PropTypes.number.isRequired,
    countryCode: PropTypes.string.isRequired,
    AddCompanyCode: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: '',
      companycodesRequested: [],
    };

    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(
      this
    );
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    if (value && value.length > 2) {
      this.getCompanyCodes(
        this.props.businessEntityId,
        this.props.countryCode,
        value
      );
    }
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      companycodesRequested: [],
      value: '',
    });
  };

  onSuggestionSelected = (event, obj) => {
    const { companyCode } = obj.suggestion;
    const { companyName } = obj.suggestion;

    this.AddCompanyCode(companyCode, companyName, this.props.countryCode);
  };

  getCompanyCodes = (businessEntityId, companyCode, lookup) =>
    AdminAPI.getCompanyCodes(businessEntityId, companyCode, lookup)
      .then(data => {
        this.setState({
          companycodesRequested: data,
        });
      })
      .catch(err => {
        throw err;
      });

  AddCompanyCode(companyCode, companyName, countryCode) {
    const restriction = {
      companyCode,
      companyName,
      countryCode,
      isEmployer: false,
      restrictions: [
        {
          typeId: 1,
          typeName: 'Cost Centre',
          options: null,
          values: [],
        },
        {
          typeId: 2,
          typeName: 'Division',
          options: null,
          values: [],
        },
        {
          typeId: 3,
          typeName: 'State',
          options: null,
          values: [],
        },
        {
          typeId: 5,
          typeName: 'Lease Type',
          options: null,
          values: [],
        },
      ],
    };
    this.props.AddCompanyCode(restriction);
  }
  render() {
    const { value, companycodesRequested } = this.state;

    const inputProps = {
      placeholder: 'Search company ..',
      value,
      onChange: this.onChange,
    };

    return (
      <div>
        <LookupContainer>
          <AutoComplete>
            <Autosuggest
              suggestions={companycodesRequested}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
              getSuggestionValue={getSuggestionValue}
              renderSuggestion={renderSuggestion}
              inputProps={inputProps}
              onSuggestionSelected={this.onSuggestionSelected}
              // alwaysRenderSuggestions
            />
          </AutoComplete>
        </LookupContainer>
        <ClearFixDiv />
      </div>
    );
  }
}

export default AddNewCompanyCode;



// WEBPACK FOOTER //
// ./src/features/admin/components/restrictions/AddNewCompanyCode.js